/* eslint-disable */
import { InputBase, makeStyles } from '@material-ui/core';
import { ArrowForward } from '@material-ui/icons';
import { useRef, useState } from 'react';

const useStyles = makeStyles({
  inputBox: {
    maxWidth: '54em',
    width: '100%',
    maxHeight: '18.2em',
    minHeight: '3.2em',
    height: 'auto',
    overflowY: 'auto',
    padding: '.8em .4em',
    borderRadius: '1.2em',
    display: 'flex',
    alignItems: 'flex-end',
    position: 'relative',
    transition: '.4s ease-in-out',
    backgroundColor: '#dee2e6',
  },
  inputWrapper: {
    width: 'calc(100% - 3.2em)',
    overflowY: 'auto',
    height: '100%',
    backgroundColor: 'inherit',
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#e7e7e7',
      background: 'red',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: 'inherit',
    },
  },
  input: {
    width: '100%',
    height: '100%',
    borderRadius: '.4em',
    padding: '0 .8em',
    fontSize: '1em',
    wordWrap: 'break-word',
    whiteSpace: 'break-spaces',
    lineHeight: '1.6em',
    outline: 'none',
    resize: 'none',
  },
  sendBtn: {
    borderRadius: '50%',
    height: '2.4em',
    width: '2.4em',
    backgroundColor: '#f26522',
    position: 'absolute',
    right: '.4em',
    bottom: '.4em',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'white',
    border: 'none',
    outline: 'none',
    cursor: 'pointer',
    transition: '.4s ease-in-out',
    '&:hover': {
      opacity: 0.7,
    },
    '&:disabled': {
      backgroundColor: 'gray',
      opacity: 0.4,
      cursor: 'default',
    },
  },
});

const InputComponent = ({ personId = '', inputRef, hasPrompt, setHasPrompt }) => {
  const classes = useStyles();

  const handlePrompt = (e) => {
    e.preventDefault();

    const { value } = e.target;

    if (!value && hasPrompt) return setHasPrompt(false);

    if (value && !hasPrompt) return setHasPrompt(true);
  };

  return (
    <div className={classes.inputBox}>
      <div className={classes.inputWrapper}>
        <InputBase
          key={`input-value-${inputRef}`}
          type="text"
          multiline
          name="prompt"
          placeholder="Mensagem CarbelBot"
          className={classes.input}
          onChange={handlePrompt}
          inputRef={inputRef}
        />
      </div>
      <button className={classes.sendBtn} disabled={!hasPrompt || !personId} type="submit">
        <ArrowForward />
      </button>
    </div>
  );
};

export default InputComponent;
